import { Button, Flex } from '@/ui';

type Props = {
  onClick: () => void;
};

/**
 * Bottom-right escape hatch out of a filter panel and into the customize panel
 * that owns the values being filtered on. Editors only: the customize panels
 * render on the edit route, so the deep link lands nowhere for a viewer.
 */
export const ManageLink = ({ onClick }: Props) => (
  <Flex justify="flex-end" pt="2">
    <Button
      _hover={{ color: 'magicPurple.700', textDecoration: 'underline' }}
      color="magicPurple.600"
      fontSize="ah-control"
      fontWeight={600}
      h="auto"
      minW={0}
      p={0}
      variant="link"
      onClick={onClick}
    >
      Manage
    </Button>
  </Flex>
);
